var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-wrapper',{staticClass:"c-AudioGuideCount",attrs:{"tag":_vm.tag}},[_c('span',{staticClass:"c-AudioGuideCountIcon"},[_vm._t("icon")],2),_c('span',{staticClass:"c-AudioGuideCountLabel"},[_vm._t("label")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }